// ZPL batch export - S48.2b.
// Genera un string ZPL concatenado con N etiquetas (1 por producto valido).
// Cada etiqueta usa la plantilla tecnica_individual + auto-layout.
// Concatenacion DIRECTA: ^XA...^XZ^XA...^XZ (sin separadores extra).
import { renderEtiquetaZpl } from './zpl_export';
import { generarCamposTecnicosConAutoLayout } from '../autolayout';

function _safeName(s) {
  return String(s || '').replace(/[^A-Za-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '');
}

export function renderEtiquetaZplBatch(productosValidos, layoutBase, sizeId, logosConfig) {
  if (!Array.isArray(productosValidos) || productosValidos.length === 0) return '';
  if (!Array.isArray(layoutBase) || layoutBase.length === 0) return '';
  const out = [];
  for (let i = 0; i < productosValidos.length; i += 1) {
    const producto = productosValidos[i];
    if (!producto) continue;
    const fields = generarCamposTecnicosConAutoLayout(producto, layoutBase, logosConfig);
    const state = { sizeId: sizeId, fields: fields };
    const zpl = renderEtiquetaZpl(state, producto, null);
    if (zpl) out.push(zpl);
  }
  return out.join('');
}

export function downloadEtiquetaZplBatch(productosValidos, factura, layoutBase, sizeId, logosConfig) {
  const zpl = renderEtiquetaZplBatch(productosValidos, layoutBase, sizeId, logosConfig);
  if (!zpl) return false;
  if (typeof document === 'undefined') return false;
  const blob = new Blob([zpl], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const fid = factura && (factura.id != null) ? factura.id : 'sin-id';
  const a = document.createElement('a');
  a.href = url;
  a.download = 'factura_' + _safeName(String(fid)) + '.zpl';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return true;
}
